import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_BANNER = "https://customer-assets.emergentagent.com/job_escuta-acolhimento/artifacts/w5rq046a_banner.png";

const resolveUrl = (url) =>
  url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export const BannerSlideshow = () => {
  const [images, setImages] = useState([DEFAULT_BANNER]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    api
      .get("/hero-images")
      .then((r) => {
        const urls = (r.data || []).map((i) => resolveUrl(i.url));
        if (urls.length > 0) setImages(urls);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setCurrent((c) => (c + 1) % images.length), 10000);
    return () => clearInterval(t);
  }, [images.length, current]);

  return (
    <div
      data-testid="site-banner-slideshow"
      className="relative w-full h-[260px] sm:h-[360px] md:h-[480px] lg:h-[600px] overflow-hidden bg-[#F5F5ED]"
    >
      {images.map((src, i) => (
        <div
          key={src + i}
          style={{ transitionDuration: "2000ms" }}
          className={`absolute inset-0 transition-opacity ease-in-out ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={src}
            alt=""
            aria-hidden
            className="absolute inset-0 w-full h-full object-cover object-center blur-2xl scale-110 opacity-60 select-none"
            draggable={false}
            loading={i === 0 ? "eager" : "lazy"}
          />
          <img
            src={src}
            alt="Cristina Moreira | Psicanálise Clínica · escuta · acolhimento · transformação"
            className="relative w-full h-full object-contain object-center select-none"
            data-testid={i === current ? "site-banner" : undefined}
            draggable={false}
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}
      {images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {images.map((_, i) => (
            <button
              key={i}
              data-testid={`banner-dot-${i}`}
              onClick={() => setCurrent(i)}
              aria-label={`Imagem ${i + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === current ? "w-6 bg-white" : "w-2 bg-white/60 hover:bg-white/80"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
